import React, { useEffect, useState } from 'react';

//redux
import { connect, useDispatch, useSelector } from 'react-redux';

//action
import {
  getLevel,
  deleteLevel,
  AccessibleFunctionLevel,
} from '../../store/level/action';

//routing
import { Link } from 'react-router-dom';
//MUI
import { Tooltip } from '@mui/material';
// type
import { OPEN_LEVEL_DIALOG } from '../../store/level/types';

// dialog
import LevelDialog from '../dialog/Level';

//sweet alert
import { alert, warning } from '../../util/Alert';
import { baseURL } from '../../util/Config';

import arraySort from 'array-sort';

//image
import noImage from '../../assets/images/noImage.png';
import Pagination from '../../pages/Pagination';

const LevelTable = (props) => {
  const dispatch = useDispatch();
  const [coinSort, setCoinSort] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [activePage, setActivePage] = useState(1);


  useEffect(() => {
    dispatch(getLevel({ start: page, limit: rowsPerPage }));
  }, [dispatch, page, rowsPerPage]);

  const { level, total } = useSelector((state) => state.level);

  useEffect(() => {
    setData(level);
  }, [level]);

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    setPage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setActivePage(1);
    setRowsPerPage(value);
  };

  const handleSearch = (e) => {
    const value = e.target.value.toUpperCase()
      ? e.target.value.trim().toUpperCase()
      : e.target.value.trim();
    if (value) {
      const data = level.filter((data) => {
        return (
          data?.name?.toUpperCase()?.indexOf(value) > -1 ||
          data?.coin?.toString()?.indexOf(value) > -1
        );
      });
      setData(data);
    } else {
      return setData(level);
    }
  };

  const handleDelete = (levelId) => {

    const data = warning();
    data
      .then((isDeleted) => {
        if (isDeleted) {
          props.deleteLevel(levelId);
          alert('Deleted!', `Level has been deleted!`, 'success');
        }
      })
      .catch((err) => console.log(err));
  };

  const handleEdit = (data) => {

    dispatch({ type: OPEN_LEVEL_DIALOG, payload: data });
  };

  const handleOpen = () => {

    dispatch({ type: OPEN_LEVEL_DIALOG });
  };

  const handleCoinSort = () => {
    setCoinSort(!coinSort);
    arraySort(data, 'coin', { reverse: coinSort });
  };

  const handleAccessFunction = (id, name) => {
    const data = {
      levelId: id,
      fieldName: name,
    };
    props.AccessibleFunctionLevel(data);
  };

  return (
    <>
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3 className="mb-3 text-white">Level</h3>
          </div>
          <div className="col-12 col-md-6 order-md-2 order-first">
            <nav
              aria-label="breadcrumb"
              className="breadcrumb-header float-start float-lg-end"
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard" className="text-danger">
                    Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Level
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header pb-0">
              <div className="row my-3">
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-8 float-left">
                  <button
                    type="button"
                    className="btn waves-effect waves-light btn-danger btn-sm float-left"
                    onClick={handleOpen}
                    id="bannerDialog"
                  >
                    <i className="fa fa-plus"></i>
                    <span className="icon_margin">New</span>
                  </button>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 float-right mt-3 mt-lg-0 mt-xl-0">
                  <form action="">
                    <div className="input-group mb-3 border rounded-pill">
                      <div className="input-group-prepend border-0">
                        <div id="button-addon4" className="btn text-danger">
                          <i className="fas fa-search mt-2"></i>
                        </div>
                      </div>
                      <input
                        type="search"
                        placeholder="What're you searching for?"
                        aria-describedby="button-addon4"
                        className="form-control bg-none border-0 rounded-pill searchBar"
                        onChange={handleSearch}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="card-body card-overflow">
              {/* <div className="d-sm-flex align-items-center justify-content-between mb-4"></div> */}

              <table className="table table-striped">
                <thead className="text-white">
                  <tr>
                    <th>No.</th>
                    <th>Image</th>
                    <th>Level Name</th>
                    <th onClick={handleCoinSort} style={{ cursor: 'pointer' }}>
                      Coin {coinSort ? ' ▼' : ' ▲'}
                    </th>
                    <th>Accessible Function</th>
                    <th>Edit</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {data?.length > 0 ? (
                    // (rowsPerPage > 0
                    //   ? data.slice(
                    //       (activePage - 1) * rowsPerPage,
                    //       activePage * rowsPerPage
                    //     )
                    //   : data
                    // )
                    data?.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            <img
                              height="50px"
                              width="50px"
                              alt="app"
                              src={data.image ? baseURL + data.image : noImage}
                              style={{
                                boxShadow:
                                  '0 5px 15px 0 rgb(105 103 103 / 00%)',
                                border: '2px solid #fff',
                                borderRadius: 10,
                                display: 'block',
                              }}
                              className="mx-auto"
                            />
                          </td>
                          <td>{data.name}</td>
                          <td>{data.coin}</td>
                          <td>
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="liveStreaming"
                                checked={
                                  Object.keys(data.accessibleFunction).includes(
                                    'liveStreaming'
                                  ) && data.accessibleFunction.liveStreaming
                                }
                                onClick={() => {
                                  handleAccessFunction(
                                    data._id,
                                    'liveStreaming'
                                  );
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="liveStreaming"
                              >
                                LiveStreaming
                              </label>
                            </div>

                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="freeCall"
                                checked={
                                  Object.keys(data.accessibleFunction).includes(
                                    'freeCall'
                                  ) && data.accessibleFunction.freeCall
                                }
                                onClick={() => {
                                  handleAccessFunction(data._id, 'freeCall');
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="freeCall"
                              >
                                Free Call
                              </label>
                            </div>

                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="cashOut"
                                checked={
                                  Object.keys(data.accessibleFunction).includes(
                                    'cashOut'
                                  ) && data.accessibleFunction.cashOut
                                }
                                onClick={() => {
                                  handleAccessFunction(data._id, 'cashOut');
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="cashOut"
                              >
                                Redeem [cashout]
                              </label>
                            </div>

                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="uploadPost"
                                checked={
                                  Object.keys(data.accessibleFunction).includes(
                                    'uploadPost'
                                  ) && data.accessibleFunction.uploadPost
                                }
                                onClick={() => {
                                  handleAccessFunction(data._id, 'uploadPost');
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="uploadPost"
                              >
                                Upload Social Post
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="uploadVideo"
                                checked={
                                  Object.keys(data.accessibleFunction).includes(
                                    'uploadVideo'
                                  ) && data.accessibleFunction.uploadVideo
                                }
                                onClick={() => {
                                  handleAccessFunction(data._id, 'uploadVideo');
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="uploadVideo"
                              >
                                Upload Video
                              </label>
                            </div>
                          </td>
                          <td>
                            <Tooltip title="Edit">
                              <button
                                type="button"
                                className="btn btn-sm btn-primary"
                                onClick={() => handleEdit(data)}
                              >
                                <i className="fa fa-edit"></i>
                              </button>
                            </Tooltip>
                          </td>
                          <td>
                            <Tooltip title="Delete">
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={() => handleDelete(data._id)}
                              >
                                <i className="fas fa-trash-alt"></i>
                              </button>
                            </Tooltip>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="7" align="center">
                        Nothing to show!!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <Pagination
                activePage={activePage}
                rowsPerPage={rowsPerPage}
                userTotal={total}
                handleRowsPerPage={handleRowsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
      <LevelDialog />
    </>
  );
};

export default connect(null, {
  getLevel,
  deleteLevel,
  AccessibleFunctionLevel,
})(LevelTable);
